<template>
    <Login />
</template>
<script>
import Login from '../components/security/Login.vue';

export default {
    components: {
        Login
    }
}
</script>
